import { Menu } from "antd";
import { h } from "preact";
import { ISidebar } from "..";
import { StyledContentSidebarMobile } from "./styled";
import { env } from "../../../../utils/env/config";

interface ISidebarMobile extends ISidebar {}

const SidebarMobile = ({
  listMenu,
  selectedMenu,
  setSelectedMenu,
}: ISidebarMobile) => {
  return (
    <StyledContentSidebarMobile>
      {/* @ts-expect-error - React/Preact type incompatibility with antd */}
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={selectedMenu}
        selectedKeys={selectedMenu}
        onClick={(e: any) => setSelectedMenu([e.key])}
        style={{ height: "90vh" }}
      >
        {listMenu}
      </Menu>
      <div
        style={{
          padding: "10px 16px",
          textAlign: "center",
          borderTop: "1px solid #f0f0f0",
          position: "absolute",
          bottom: 0,
          width: "100%",
        }}
      >
        {env.version}
      </div>
    </StyledContentSidebarMobile>
  );
};

export default SidebarMobile;
